export default __webpack_public_path__ + "static/media/fridge1-after2-768w.8f00a889.avif";